import { verifyAge } from './verify-age';

export const transformYearOfBirthDefaultValue = (yearOfBirth: Nullable<string>) =>
  yearOfBirth && verifyAge(yearOfBirth) ? new Date(yearOfBirth).getUTCFullYear() : undefined;

export const transformYearOfFirstLicenceDefaultValue = (yearOfFirstLicence: Nullable<string>) =>
  yearOfFirstLicence && yearOfFirstLicence?.toString() !== '1' ? yearOfFirstLicence : null;
